import { useContext } from 'react'

import { TemplateContext } from '@contexts/template'

const useTemplate = () => useContext(TemplateContext)

export default {
  useTemplate,
}
